const PENDING_ORDER_FIELDS_EXCLUDED_FROM_ADDRESS = [
    'commande',
    'freeDelivery',
    'lastUpdateOrder',
    'managementFee',
    'orderType',
    'shopId',
    'totalPriceOrder',
    'totalProductPriceOrder',
    'totalProductPriceWithPromo',
    'id'
];


export const sanitizePendingOrderAddress = (address: any) => {
    if (!address || typeof address !== 'object' || Array.isArray(address)) {
        return address;
    }

    const sanitizedAddress = { ...address };
    PENDING_ORDER_FIELDS_EXCLUDED_FROM_ADDRESS.forEach((field) => {
        delete sanitizedAddress[field];
    });
    return sanitizedAddress;
};